import { CalendarMeta, Era, WeekNote } from '../types';
import { getCurrentWeekIndex, parseISODate } from '../utils/date';

export type StateListener = () => void;

class AppStore {
  public meta: CalendarMeta = {
    birthdate: '2000-01-01',
    total_years: 120,
    title: 'Life Calendar',
    bio: '',
    eras: [],
    isAdmin: false,
  };

  public notes: Map<number, WeekNote> = new Map();
  public currentWeekIndex: number = 0;
  public highlightedEraId: string | null = null;
  public selectedWeekIndex: number | null = null;

  private listeners: Set<StateListener> = new Set();

  subscribe(listener: StateListener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  notify(): void {
    this.listeners.forEach((listener) => listener());
  }

  setMeta(meta: CalendarMeta): void {
    this.meta = meta;
    const birthdate = parseISODate(meta.birthdate);
    this.currentWeekIndex = getCurrentWeekIndex(birthdate);
    this.notify();
  }

  setNotes(notesList: WeekNote[]): void {
    this.notes.clear();
    for (const note of notesList) {
      this.notes.set(note.week_index, note);
    }
    this.notify();
  }

  setNote(note: WeekNote): void {
    this.notes.set(note.week_index, note);
    this.notify();
  }

  removeNote(weekIndex: number): void {
    this.notes.delete(weekIndex);
    this.notify();
  }

  setEras(eras: Era[]): void {
    this.meta.eras = eras;
    this.notify();
  }

  setHighlightedEra(id: string | null): void {
    this.highlightedEraId = this.highlightedEraId === id ? null : id;
    this.notify();
  }

  setIsAdmin(isAdmin: boolean): void {
    this.meta.isAdmin = isAdmin;
    this.notify();
  }

  getBirthDate(): Date {
    return parseISODate(this.meta.birthdate);
  }

  getTotalWeeks(): number {
    return this.meta.total_years * 52;
  }
}

export const store = new AppStore();
